import { appConfig } from '@oneview/config';
import { createQueryFn } from '@oneview/redux/utils';
import { CaseSubmitData } from '@orbis-systems/orbis-api-middleware';
import { showToast } from '@orbis-systems/orbis-react-toolkit';
import { CountryCode } from 'libphonenumber-js';
import { api } from './baseApi';

// FIXME: This is a temporary fix to get the response type from the backend.
// We need to update the backend to return the correct type.
interface CaseResponse {
    success: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload: any;
}

export interface Country {
    id: number;
    code: CountryCode;
    dialCode: string;
    name: string;
}

export const miscApi = api.injectEndpoints({
    endpoints: (build) => ({
        getMarketStatus: build.query({
            queryFn: createQueryFn(async (_: void, { extra: api }) => api.orbisMiddleware.market.getMarketStatus()),
        }),
        getLatestVersion: build.query({
            queryFn: createQueryFn(async (_: void, { extra: api }) => {
                const { data } = await api.middlewareSdk.get<{ versionNumber: string }>(
                    '../versioning/:appId',
                    undefined,
                    {
                        pathParams: { appId: appConfig.appId },
                    },
                );
                return data.versionNumber;
            }),
        }),
        createCase: build.mutation<CaseResponse, CaseSubmitData>({
            queryFn: createQueryFn(async (data: CaseSubmitData, { extra: api, dispatch }) => {
                const response = (await api.orbisMiddleware.branch.createCase(data)) as CaseResponse;
                if (response.success === false) {
                    dispatch(showToast('Error sending, please try again.'));
                } else {
                    dispatch(showToast('Sent'));
                }
                return response;
            }),
        }),
        getPhoneCountryCodes: build.query({
            queryFn: createQueryFn(async (_: void, { extra: api }) => {
                const response = await api.uma.countries.get();
                const data: Country[] = response.data.countries.map((item) => {
                    return { ...item, dialCode: item.dial_code, code: item.code as CountryCode };
                });
                return data;
            }),
        }),
    }),
});

export const {
    useLazyGetLatestVersionQuery,
    useGetMarketStatusQuery,
    useCreateCaseMutation,
    useGetPhoneCountryCodesQuery,
} = miscApi;
